export const blogDetailConstant = {
    GET_BLOG_DETAIL_REQUEST : "GET_BLOG_DETAIL_REQUEST",
    GET_BLOG_DETAIL_SUCCESS : "GET_BLOG_DETAIL_SUCCESS",
    GET_BLOG_DETAIL_FAILURE : "GET_BLOG_DETAIL_FAILURE",  

    GET_BLOGSLUG_DETAIL_REQUEST : "GET_BLOGSLUG_DETAIL_REQUEST",
    GET_BLOGSLUG_DETAIL_SUCCESS : "GET_BLOGSLUG_DETAIL_SUCCESS",
    GET_BLOGSLUG_DETAIL_FAILURE : "GET_BLOGSLUG_DETAIL_FAILURE", 
}